//import Model from "~/models/eschoolplus/registration/Student";
import Model from "~/models/_Model";
import Note from "./Note";

export default class StudentMeta extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile";
  }

  // Set the resource route of the model
  resource() {
    return "students";
  }

  relations() {
    return {
      notes: Note,
    };
  }

  find(id) {
    return super.find(`${id}/metadata`);
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
}
